export const SYSTEM_ADMIN_PERMISSION = 'SYSTEM_ADMIN'
export const SYSTEM_ADMIN_ROLE = 'SYSTEM ADMIN'